import React from "react";
import { useTranslation } from "react-i18next";
import "../CheckoutPanel/CheckoutPanel.css";

const SummaryHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="summary-header">
      <span>{t("cart.item") || "Product"}</span>
      <span>{t("cart.quantity") || "Quantity"}</span>
      <span>{t("cart.price") || "Price"}</span>
    </div>
  );
};

export default SummaryHeader;
